import axios from "axios";
import { IReviewSource } from "../../../types/types";

export const getReviewSources = async (): Promise<IReviewSource[]> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get-review-sources`
    );
    return response.data.data as IReviewSource[];
  } catch (e) {
    console.log("error getting review sources");
    return [];
  }
};

export const stockReviews = [
  {
    reviewer: "Ali Gibson",
    review:
      "Highly recommend! Showed up on time, did a great job, reasonably priced.",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Aubree Bowers",
    review:
      "Reach out today! They came in clutch when I was in need. Thank you!",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Aldo Boone",
    review:
      "Professional, easy to work with, and quick to respond to any questions! Amazing team.",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Kadin Fuller",
    review:
      "So easy to work with! Will definitely use them again in the future.",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Rihanna Rivas",
    review:
      "I tell everyone I know to give them a call - they're the best there is!",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Linda Perkins",
    review:
      "Stop thinking about it, and just call them! They're worth every penny.",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Marlene Litts",
    review:
      "Wouldn't go to anyone else. They're the best there is. Call them now!",
    stars: 5,
    source: "Facebook",
  },
  {
    reviewer: "Reagan Owen",
    review: "Easy to find, easy to work with, all around a 5-star experience.",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "Chaya Kline",
    review:
      "Recommend them 100% - so responsive and do great work. I keep getting compliments!",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "James Valdez",
    review:
      "Found them through Google, showed up the next day, stuck to their quote.",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "McKenna Mueller",
    review: "Reliable, trustworthy, all around stellar. Check them out!",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "Kaleb Bentley",
    review:
      "It's simple really - they do great work at the right price. Calling them is a no brainer.",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "Heath Anthony",
    review:
      "Easy to follow and transparent pricing. Work quickly but do a good job. Had a great experience!",
    stars: 5,
    source: "Google",
  },
  {
    reviewer: "Jacoby Wheeler",
    review: "Just all around awesome people to work with - great experience.",
    stars: 5,
    source: "Google",
  },
];
